//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "bp",
  data() {
    return {
      disabled: false,
      hasScore: false,
      form: {
        item1: '',
        item2: '',
        item3: '',
      },
      item1List: [
        { value: '1', name: '放松' },
        { value: '2', name: '部分紧张(如眉弓压低)', shortName: '部分紧张' },
        { value: '3', name: '完全紧张(如眼睑紧闭)', shortName: '完全紧张' },
        { value: '4', name: '僵硬' },
      ],
      item2List: [
        { value: '1', name: '没有活动' },
        { value: '2', name: '轻度屈曲' },
        { value: '3', name: '完全屈曲伴手指弯曲' },
        { value: '4', name: '永久性回缩' },
      ],
      item3List: [
        { value: '1', name: '耐受' },
        { value: '2', name: '咳嗽但大多数时间可耐受' },
        { value: '3', name: '对抗呼吸机' },
        { value: '4', name: '无法控制通气' },
      ],
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/bp.vue